import TruncatedTextRenderer from "./TruncatedTextRenderer"

function CustomIDRenderer(props) {
    const { instance } = props
    return <TruncatedTextRenderer value={instance.custom_id || instance.id} />
}

export default CustomIDRenderer
